export const cleanupSuccessfulResume = ({
    uploadState,
    uploadsDispatch,
    pausedNotificationKey,
    closeNotification,
    clearStalled = true,
}) => {
    if (!['active', 'completed'].includes(uploadState)) return;

    if(clearStalled) uploadsDispatch({type: 'clearStalledAssets'});
    if (pausedNotificationKey.current) {
        closeNotification(pausedNotificationKey.current);
        pausedNotificationKey.current = null;
    }
};
